const initialState = {
    localities: { data: { data: [], pagination: {} } },
    locality: { data: null }
};

const localityReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_ALL_LOCALITIES':
            return {
                ...state,
                localities: { data: action.data }
            };
        case 'GET_LOCALITY_BY_ID':
            return {
                ...state,
                locality: { data: action.data }
            };
        default:
            return state;
    }
};

export default localityReducer;
